module.exports = __webpack_public_path__ + "img/grid_map_menu_select.e3273076.svg";